import { AxiosResponse } from 'axios'
import api from '~/services/api'
import {
  IGetMenuResponse,
  IGetMenuTransform,
  ICreateOrderPayload,
  ICreateOrderResponse
} from './../model/types'
import { transformMenuUser } from './../utils'

export const getMenuUser = async (restId: number, baseUrl?: string): Promise<IGetMenuTransform> => {
  const { data }: AxiosResponse<IGetMenuResponse> = await api.get(`${baseUrl ?? process.env.MENU_URL}/user-menu/shop/${restId}`)

  return transformMenuUser(data)
}

export const requestAddingMenu = async (id: number, ip: string) => {
  return await api.post(`shop/${id}/want/menu`, { client_ip: ip })
}

export const createOrderByTable = async (payload: ICreateOrderPayload): Promise<ICreateOrderResponse> => {
  const { data }: AxiosResponse<ICreateOrderResponse> = await api.post('create-order/create-by-table', payload)
  return data
}

export const getMenuStopList = async (restId: number) => {
  return await api.post(`menu/shop/${restId}/stop-list`)
}
